module.exports = __webpack_public_path__ + "img/avatar.a8c7be09.png";